import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import {
  selectCardDependsOn,
  selectCardUsedBy,
} from '../../../../reducers/documentation/documentationCardReducer';
import { ConfigurationItemMap } from '../../configuration-item-tables/shared/helpers';
import { checkIfActive } from '../../helpers';
import { SalesforceItem } from '../../../parser/ParserTypes';

interface UseGetParsedDependencies {
  metadataId: string;
  type: 'dependsOn' | 'usedBy';
  onlyActive: boolean;
}

export const useGetParsedDependencies = ({
  metadataId,
  type,
  onlyActive,
}: UseGetParsedDependencies) => {
  const selector = type === 'dependsOn' ? selectCardDependsOn : selectCardUsedBy;
  const rawItems = useSelector(selector(metadataId));

  return useMemo(() => {
    if (!rawItems) {
      return {} as ConfigurationItemMap;
    }

    const result = {} as ConfigurationItemMap;

    Object.entries(rawItems).forEach(([key, items]) => {
      const filtered = (items as SalesforceItem[]).filter((item) =>
        checkIfActive(onlyActive, item),
      );
      if (filtered.length > 0) {
        result[key] = filtered;
      }
    });

    return result;
  }, [rawItems, onlyActive]);
};
